//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export enum HospTypeEnum {
    PerDiem = 1,
    Travel = 2,
    Locums = 3,
    NonClinical = 4,
    Permanent = 6,
    WorkforceDisruptionClinical = 7,
    WorkforceDisruptionNonClinical = 8,
    AccessControl = 9,
    InterimLeadership = 10,
    PayrollServices = 11,
}